import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/public/SEO";
import { Calendar, MapPin } from "lucide-react";

const CAT_LABEL = {
  festival: "Festival", konser: "Konser", kultur: "Kültür",
  maraton: "Spor", sergi: "Sergi", balon: "Balon",
};

function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso + "T12:00:00");
  return d.toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" });
}

export default function KapadokyaTakvimiPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  useEffect(() => {
    (async () => {
      const url = `/events?upcoming=true${filter ? `&category=${filter}` : ""}`;
      const { data } = await api.get(url);
      setItems(data || []);
    })();
  }, [filter]);

  return (
    <>
      <SEO title="Kapadokya Takvimi — Festival, Konser, Etkinlikler"
           description="Kapadokya'nın yıllık festival, konser, sergi ve kültür etkinliklerinin merkezi takvimi." />
      <section className="pt-40 pb-12 max-w-7xl mx-auto px-6 md:px-12" data-testid="takvim-header">
        <div className="text-[10px] tracking-[0.28em] uppercase text-cc-sepia mb-5">Yıllık Takvim</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cc-text leading-[1.02] mb-8">
          Kapadokya<br/><span className="italic">Takvimi.</span>
        </h1>
        <p className="max-w-2xl text-cc-muted text-lg leading-[1.85]">
          Festivaller, konserler, kültür etkinlikleri, sergiler ve sportif organizasyonlar — bölgenin
          yıl boyu canlı kalmasını sağlayan etkinlikler tek bir takvimde.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 border-t border-cc-border pt-6">
        <div className="flex flex-wrap items-center gap-x-8 gap-y-3" data-testid="takvim-filter">
          <button onClick={() => setFilter("")} className={`text-xs tracking-[0.22em] uppercase transition ${!filter ? "text-cc-sepia" : "text-cc-muted hover:text-cc-text"}`}>Tümü</button>
          {Object.entries(CAT_LABEL).map(([key, label]) => (
            <button key={key} onClick={() => setFilter(key)}
              className={`text-xs tracking-[0.22em] uppercase transition ${filter === key ? "text-cc-sepia" : "text-cc-muted hover:text-cc-text"}`}>
              {label}
            </button>
          ))}
        </div>
      </section>

      <section className="py-12 md:py-20 max-w-7xl mx-auto px-6 md:px-12 pb-32" data-testid="takvim-list">
        {items.length === 0 && <p className="text-cc-muted">Bu kategoride yaklaşan etkinlik yok.</p>}
        <div className="space-y-1">
          {items.map((ev, i) => (
            <div key={ev.id} className="grid md:grid-cols-12 gap-6 py-8 border-b border-cc-border items-center cc-reveal" style={{ animationDelay: `${0.04 * i}s` }} data-testid={`event-${ev.slug}`}>
              <div className="md:col-span-2">
                <Calendar size={14} className="text-cc-sepia mb-2" />
                <div className="font-serif text-2xl text-cc-text leading-none">{fmtDate(ev.starts_on).split(" ")[0]}</div>
                <div className="text-xs text-cc-muted">{fmtDate(ev.starts_on).split(" ").slice(1).join(" ")}</div>
              </div>
              <div className="md:col-span-7">
                <div className="text-[10px] tracking-[0.22em] uppercase text-cc-sepia mb-2">{CAT_LABEL[ev.category] || ev.category}</div>
                <h3 className="font-serif text-2xl md:text-3xl text-cc-text mb-2">{ev.title}</h3>
                <p className="text-cc-muted leading-relaxed">{ev.description}</p>
              </div>
              <div className="md:col-span-3 text-sm text-cc-muted">
                {ev.location && <p className="flex items-center gap-2"><MapPin size={14} className="text-cc-sepia" /> {ev.location}</p>}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
